/**
 * Created by Jasmine on 2018/1/19.
 */

import {observable} from "mobx";
import {request, apis} from '../../../utils/net';

const store = observable({

    add: {
        visible: false,
    },

    edit: {
        visible: false,
        default: {},
        id: '',
    },

    // 用户可新增总数
    buy_total: 0,

    //获取子账号详情
    getItemInfo(id){
        //清空
        store.edit.default = {};
        request({
            method: 'POST',
            url: apis.postSubaccInfo, data: {drawer_id: id}
        }).then(r => {
            store.edit.default = r;
            store.edit.visible = true;
            store.edit.id = id;
        })
    },

    //门店列表
    storeList: [],
    staffList: [],

    //当前查询条件
    formStore: '',
    formStaff: '',

    //表格数据
    grid: {
        list: [],
        page: 1,
        size: 10,
        total: 0,
    },

    //绑定微信二维码
    qrcode: {
        visible: false,
        img: '',
    },

    //查询翻页
    query(page){
        page = page || 1;
        request({
            method: 'POST',
            url: apis.postSubaccList, data: {
                page: page,
                nickname: store.formStaff,
                store_id: store.formStore,
                page_size: store.grid.size,
            }
        }).then(function (r) {
            store.grid.list = r.list;
            store.grid.size = r.page_size;
            store.grid.page = r.page;
            store.grid.total = r.total_count;
            store.buy_total = r.buy_total;
        })
    },

    //获取门店列表
    getStoreList(){
        request({url: apis.getSysShops}).then(function (r) {
            store.storeList = r;
        })
    },
    getStaffList(){
        method:'POST',
            request({url: apis.postDrawerList}).then(function (r) {
                store.staffList = r;
            })
    }
});

export default store;
